import React from "react";
import { Flame } from "lucide-react";
import {
  BBQQuickActions,
  BBQPendingPaymentsPanel,
  BBQBookingsTable,
  BBQResidentContacts,
  BBQStatistics,
} from "../../components/admin";

const AdminBBQTab = ({
  activeSubView,
  setActiveSubView,
  bbqBookings,
  bbqPendingBookings,
  onVerifyBbqPayment,
  onCancelBbqBooking,
  onChangeBbqDate,
  onTriggerUnpaidAlert,
}) => {
  return (
    <div className="space-y-6">
      <BBQQuickActions
        activeSubView={activeSubView}
        setActiveSubView={setActiveSubView}
        pendingCount={bbqPendingBookings.length}
      />

      {activeSubView === 'bbq-pending' && (
        <BBQPendingPaymentsPanel
          pendingBookings={bbqPendingBookings}
          onVerifyPayment={onVerifyBbqPayment}
          onCancelBooking={onCancelBbqBooking}
        />
      )}

      {activeSubView === 'bbq-all' && (
        <div className="brutal-card">
          <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
            <Flame className="text-orange-500" /> All BBQ Bookings
          </h3>
          <BBQBookingsTable
            bookings={bbqBookings}
            onVerifyPayment={onVerifyBbqPayment}
            onCancel={onCancelBbqBooking}
            onChangeDate={onChangeBbqDate}
            pageSize={15}
          />
        </div>
      )}

      {activeSubView === 'bbq-contacts' && (
        <BBQResidentContacts bookings={bbqBookings} />
      )}

      <BBQStatistics
        bbqBookings={bbqBookings}
        onTriggerUnpaidAlert={onTriggerUnpaidAlert}
      />
    </div>
  );
};

export default AdminBBQTab;
